import { useLocation, useNavigate } from 'react-router';
import { PageContainer, Paper, CustomButton } from '@medtronic/pecc-react-component-library-js';
import { Box, Typography, useTheme } from '@mui/material';
import { WarningAlt } from '@carbon/icons-react';
import text from './constants';

const NotFound = () => {
  const { palette } = useTheme();
  const { search } = useLocation();
  const navigate = useNavigate();
  const { titleText, mainText, subText } =
    text[new URLSearchParams(search).get('status')] || text[404];

  return (
    <PageContainer
      centerContentVertically
      centerContentHorizontally
      sx={{ bgcolor: palette.neutral10.main }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Paper size="l" customHeight="50rem">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              columnGap: '12rem',
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: '2rem' }}>
              <Typography variant="headingMAlt">{titleText}</Typography>
              <Typography variant="body1">{mainText}</Typography>
              <Typography variant="body1">{subText}</Typography>
            </Box>
            <Box>
              <WarningAlt size="25rem" color={palette.borderGray.main} />
            </Box>
          </Box>
        </Paper>
        <Paper size="l" customHeight="10rem">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <CustomButton
              buttonType="primary"
              label="Refresh page"
              size="large"
              onClick={() => {
                navigate(-1);
              }}
            />
          </Box>
        </Paper>
      </Box>
    </PageContainer>
  );
};

export default NotFound;
